import { Page } from '@/core/architecture'

import { PasswordResetTemplate } from './template'
import { useViewModel } from './viewModel'

export const PasswordReset: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <PasswordResetTemplate
      state={state}
      onSubmitPasswordReset={actions.onSubmitPasswordReset}
    />
  )
}
